export const asToolsApi = {
  asToolApi: 'https://us-central1-anchor-tools.cloudfunctions.net/api/v1',
  asToolApiKey: '$n3Nnua81Ka1uCV8YDTDYeLN0TRXeS9yDqeTGLhbDJcEallsFVRS9ryW8wtg86cqf_R5PP6kWfTyd1vrncjcyC',
};
